import { httpPost } from '@inner-source/cis-shared/transports';

const postSendStar = ({ id, from, to, message }) => httpPost('/send-star', { id, from, to, message });

export default postSendStar;
